import { render, staticRenderFns } from "./document-select.vue?vue&type=template&id=3af4e03b&scoped=true"
import script from "./document-select.vue?vue&type=script&lang=js"
export * from "./document-select.vue?vue&type=script&lang=js"
import style0 from "./document-select.vue?vue&type=style&index=0&id=3af4e03b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af4e03b",
  null
  
)

export default component.exports